export default __webpack_public_path__ + "c8ba06b326575f134eb08824856a7f71.png";